import { render, staticRenderFns } from "./TransferPaymentLink.vue?vue&type=template&id=1b940b4b&"
import script from "./TransferPaymentLink.vue?vue&type=script&lang=js&"
export * from "./TransferPaymentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports